module.exports = __webpack_public_path__ + "media/dogs/dogAvatar3-c9e52d0e.svg";